var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetaDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0268 17.2769C11.8404 16.4633 13.1595 16.4633 13.9731 17.2769L25 28.3037L36.0268 17.2769C36.8404 16.4633 38.1595 16.4633 38.9731 17.2769C39.7867 18.0905 39.7867 19.4095 38.9731 20.2231L26.4731 32.7231C25.6595 33.5367 24.3404 33.5367 23.5268 32.7231L11.0268 20.2231C10.2132 19.4095 10.2132 18.0905 11.0268 17.2769Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0268 17.2769C11.8404 16.4633 13.1595 16.4633 13.9731 17.2769L25 28.3037L36.0268 17.2769C36.8404 16.4633 38.1595 16.4633 38.9731 17.2769C39.7867 18.0905 39.7867 19.4095 38.9731 20.2231L26.4731 32.7231C25.6595 33.5367 24.3404 33.5367 23.5268 32.7231L11.0268 20.2231C10.2132 19.4095 10.2132 18.0905 11.0268 17.2769Z",
    fill: "black",
    fillOpacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaDown);
export default __webpack_public_path__ + "static/media/setaDown.dc601bd7cf11fee6f357f18738fe6189.svg";
export { ForwardRef as ReactComponent };